export default __webpack_public_path__ + "static/media/referral.559ddb7f.svg";